module.exports = __webpack_public_path__ + "h5/img/icon_growsystem_upgrade_congratulations.58160a81.png";